import { Breadcrumb, Card, Col, Row,Alert, EventHandler } from 'client/CommonComponents';
import RequisitionType from './RequisitionType';
import './CreateOrder.scss'
import Request from './Request';
import MyCart from './MyCart';
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';

interface IProps {
  breadcrumlist?: any,
  navigate?: any,
  handleClickBack?: any,
  handleClickAdd?: any,
  itemDetailComponent?: any,
  mobile: boolean,
  mycartButton: any,
  showCart: boolean,
  handleClickAddCart?: any,
  dismissSuccessAlert?: any,
  successAlert: boolean,
  setItemDetailComponent?:any,
  setShowCart?:any,
  setSuccessAlert?:any,
  showCreateRequisition?:boolean,
  setShowCreateRequisition?:any,
  setShowCartClicked?:any,
  reasonCartList?:any,
  showCartClicked:boolean,
  setShowCatalog:any,
  showCatalog:any,
  Popupcontent: any,
  hideDialog : any,
  isUpdateSuccessAlert?:boolean,
  setIsRequestDeleted?: any,
  isRequestDeleted?: any,
  setIsReasonDeleted?: any,
  isReasonDeleted?: any,
  setIsDealerChangesOccured?: any,
  isDealerChangesOccured?: any,
}

const CreateOrder = (props: IProps) => {
  const {
    setIsRequestDeleted,
    isRequestDeleted,
    setIsReasonDeleted,
    isReasonDeleted,
    setIsDealerChangesOccured,
    isDealerChangesOccured
  } = props

  return (<>
    <div className='breadCrumbBlock'>

      {
        // props.mobile ?
        //   <div className='backIcon' onClick={props.handleClickBack}>
        //     <img src={arrowIcon} alt='back Btn'/>       
        //   </div> :
        <EventHandler onEvent={props.handleClickBack} data-attribute="CreateOrder_Default_EventHandler">
          <div className='backButton mb-sm-2 mb-3'>
            <span className="fa fa-chevron-left"></span>
            Back
          </div>
        </EventHandler>
      }
      <div className='breadcrumbList'>
        <Breadcrumb items={props.breadcrumlist} maxDisplayedItems="5"  data-attribute="CreateOrder_Default_Breadcrumb" />
      </div>
      {
        props.mobile && !props.showCart ?
          <EventHandler onEvent={props.mycartButton} data-attribute="CreateOrder_Default_EventHandler_2">
            <div className='mycartButton'>
              My Cart ({(props.reasonCartList !== undefined) ? props.reasonCartList.length : 0})
            </div>
          </EventHandler> : null
      }
    </div>

    <Row>
      <Col xs={12} md={12} lg={8} className={`createRequisition ${props.showCreateRequisition? '':'hideCreate'}`}>
        {<RequisitionType mobile={props.mobile} setShowCatalog={props.setShowCatalog} setItemDetailComponent={props.setItemDetailComponent} setShowCart={props.setShowCart}/>}
        {<Request isDealerChangesOccured = {isDealerChangesOccured} setIsDealerChangesOccured = {setIsDealerChangesOccured} isReasonDeleted = {isReasonDeleted} setIsReasonDeleted = {setIsReasonDeleted} isRequestDeleted = {isRequestDeleted} setIsRequestDeleted = {setIsRequestDeleted} mobile={props.mobile} showCartClicked={props.showCartClicked}  setShowCartClicked={props.setShowCartClicked} setShowCreateRequisition={props.setShowCreateRequisition} setSuccessAlert={props.setSuccessAlert} setShowCart={props.setShowCart} showCatalog = {props.showCatalog}/>}
      </Col> 
      {
        props.showCart ?
        <Col xs={12} md={12} lg={4} className='myCartBlock'>
          <Card data-attribute="CreateOrder_Default_Card">
            <Alert
              className="alert-message successAlert"
              showAlert={props.successAlert}
              dismissAlert={props.dismissSuccessAlert}
              type="success"
              text={props.isUpdateSuccessAlert ? "Updated Successfully" : "Successfully added to the cart"}
             data-attribute="CreateOrder_Default_Alerts" />
            <MyCart setIsReasonDeleted = {setIsReasonDeleted} setIsRequestDeleted = {setIsRequestDeleted}/>
          </Card>
        </Col>: 
        props.successAlert &&
        <Alert
              className="alert-message successAlert"
              showAlert={props.successAlert}
              dismissAlert={props.dismissSuccessAlert}
              type="success"
              text={"Updated Successfully"}
         data-attribute="CreateOrder_Default_Alerts_2" />
      }
     
    </Row>
    {props.Popupcontent.isDialogVisible ? 
      <CancelConfirmationPopup
        hideDialog={!props.Popupcontent.isDialogVisible}
        onDismiss={props.hideDialog}
        Popupcontent={props.Popupcontent}
        popupOutlinebtnOnclick={() => props.Popupcontent.popupConfirmationOutlinebtnOnclick()}
        popupPrimarybtnOnclick={() => props.Popupcontent.popupConfirmationPrimarybtnOnclick()}
      /> : ""}
  </>)
}

export default CreateOrder;
